import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  '& $cardContent': {
    color: TextColors.light,
  },
  '& $caption': {
    color: hexToRGBA(TextColors.light, TextOpacities.light1),
  },
  '& $category': {
    color: SecondaryColors.main,
  },
};

const lightTheme = {
  '& $cardContent': {
    color: TextColors.dark,
  },
  '& $caption': {
    color: hexToRGBA(TextColors.dark, TextOpacities.light1),
  },
  '& $category': {
    color: SecondaryColors.dark,
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    bgCard: {
      '&.dark-theme': darkTheme,
      '&.light-theme': lightTheme,
      '&.v-align-center': {
        '& $notCardImage': {
          justifyContent: 'center',
        },
      },
    },
    card: {
      height: '100%',
      position: 'relative',
    },
    cardImage: {},
    cardContent: {
      '&.MuiCardContent-root': {
        padding: muiTheme.spacing(4),

        '&.MuiCardContent-root:last-of-type': {
          paddingBottom: muiTheme.spacing(4),
        },
      },
    },
    cardLogo: {
      maxHeight: '65px',

      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },

      '& img': {
        height: '100%',
        maxHeight: '65px',
        width: 'auto',
      },
    },
    category: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1),

        '& + .MuiCardActions-root': {
          marginTop: muiTheme.spacing(3),
        },
      },
    },
    categoryTop: {
      marginBottom: muiTheme.spacing(2),
    },
    cardHeading: {
      '&.MuiTypography-root': {
        color: 'inherit',

        '&:not(:last-child)': {
          marginBottom: muiTheme.spacing(2),
        },
      },
    },
    cardDescription: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    cardActions: {
      '&.MuiCardActions-root': {
        padding: 0,

        '& + .MuiTypography-caption': {
          marginTop: muiTheme.spacing(3),
        },
      },
    },
    spacer: {
      flexGrow: 1,
    },
    caption: {
      '&.MuiTypography-root': {
        '& p': {
          marginTop: 0,
          marginBottom: 0,

          '&:not(:first-child)': {
            marginTop: muiTheme.spacing(1),
          },
        },
      },
    },
    primaryCTA: {
      marginTop: muiTheme.spacing(2),
    },
    divider: {
      padding: '0 8px',
    },
    notCardImage: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    cardLink: {
      '&.MuiButtonBase-root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
        top: 0,
        left: 0,
      },
    },
    cardActionsLink: {
      '&.MuiButtonBase-root': {
        position: 'relative',
        zIndex: 2,
      },
    },
  }),
  { name: 'GenFeaturedContentRowCard' },
);

export default useStyles;
